import type { ReactNode } from 'react';
import { cx } from './classes.js';

/** Profile fact row: label · value (Profile artboard, 200px label column). */
export function DefRow({
  label,
  children,
  first = false,
}: {
  label: ReactNode;
  children: ReactNode;
  first?: boolean;
}) {
  return (
    <div
      className={cx(
        'grid grid-cols-[200px_minmax(0,1fr)] gap-4 px-6 py-3.5 text-[14px]',
        !first && 'border-t border-line',
      )}
    >
      <span className="text-mute">{label}</span>
      <span className="min-w-0 break-words">{children}</span>
    </div>
  );
}
